import React, { useState, useEffect, useMemo } from 'react'
import moment from 'moment'
import _ from "lodash"
import { Checkbox, Icon, message, Popover, Modal, Tooltip } from 'antd'
import { deleteReuseEmbroidery, getHistoryEmbroideryDesign, getListSku, getReusedEmbroideryDesignOrders } from '../../../services/api/3dApi'
import ModalEmbroideryInfo from '../../batch/components/data/ModalEmbroideryInfo'
import ModalReusedEmbroideryDesignOrders from './ModalReusedEmbroideryDesignOrders'
import HistoryModal from '../../shared/HistoryModal'

const ReuseEmbroideryInfoTable = (props) => {
    const { data = [], loading, reload, selectedRowIds = [], setSelectedRowIds } = props

    const rowIds = data.map(d => d._id)
    const allSelected = rowIds.length > 0 && rowIds.every(id => selectedRowIds.includes(id))
    const indeterminate = selectedRowIds.length > 0 && !allSelected

    const handleToggleAll = (e) => {
        setSelectedRowIds(e.target.checked ? rowIds : [])
    }
    const handleToggleRow = (id) => {
        setSelectedRowIds(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        )
    }

    const [dataType, setDataType] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    const [sideActive, setSideActive] = useState([])
    const [productType, setProductType] = useState('')
    const [idFocus, setIdFocus] = useState('')
    const [isOpenModalDelete, setIsOpenModalDelete] = useState(false)
    const [items, setItems] = useState([])
    const [ordersErr, setOrderErr] = useState({})
    const [isOpenModalHistory, setIsOpenModalHistory] = useState(false)
    const [itemId, setItemId] = useState('')

    const normalizedItems = useMemo(() => Array.isArray(items) ? items : [], [items])

    const allIds = useMemo(() => normalizedItems.map(i => i._id), [normalizedItems])

    const [selectItems, setSelectItems] = useState(allIds)

    const renderLinkFile = (files = []) => {
        if (!files.length) return

        return (
            <div className="d-flex flex-column">
                {
                    files.map(f => (
                        <div>
                            <a
                                href={_.get(f, 'url')}
                                target='_blank'
                                rel="noopener noreferrer"
                                className='font-weight-bold cursor-pointer'
                                style={{ color: '#1890ff' }}
                            >
                                <span className='font-weight-bold mr-2'>{_.get(f, 'file_name')}</span>
                                <Icon type="download" />
                            </a>
                        </div>
                    ))
                }
            </div>
        )
    }

    const _handleDelete = async (id) => {
        try {
            const payload = {}
            if (!!selectItems.length) payload.apply_embroidery_design_orders = selectItems

            const { data: res } = await deleteReuseEmbroidery(id, payload)
            const { data, success, error } = res

            if (!success) throw new Error(error)

            const { invalid_orders = {} } = data || {}
            if (!!Object.keys(invalid_orders).length) {
                return setOrderErr(invalid_orders)
            }

            message.success("Xoá thành công!")
            setIsOpenModalDelete(false)
            reload()
        } catch (e) {
            message.error(e.message)
        }
    }

    const fetchDataType = async () => {
        if (!productType) return

        try {
            const dataType = {}
            const { data: res } = await getListSku({ sku: [productType] })
            const { data } = Object.assign({}, res)
            const { items = [] } = Object.assign({}, data)

            dataType[productType] = !!items.length ? items[0] : {}
            setDataType(dataType)

        } catch (error) {
            console.error(error)
        }
    }

    const fetchListItemWithSameEmbroidery = async (id) => {
        setItems([])
        try {
            const { data: res } = await getReusedEmbroideryDesignOrders(id)
            const { success, data, message: mess, } = res || {}
            if (!success) throw new Error(mess || 'Đã có lỗi xảy ra khi lấy danh sách item')

            const { orders = [] } = data

            setItems(orders || [])
        } catch (err) {
            const errMsg = !!err.message ? err.message : 'Đã có lỗi xảy ra khi lấy danh sách item'
            console.log(errMsg)
            setItems([])
        }
    }

    useEffect(() => {
        if (idFocus) fetchListItemWithSameEmbroidery(idFocus)
    }, [idFocus])

    useEffect(() => {
        fetchDataType()
    }, [productType])

    return (
        <div div className="ReuseEmbroideryItemTable" >
            <table className="table table-borderless table-striped">
                <thead className='thead-light PackingItemHeader'>
                    <tr>
                        <th style={{ width: 40 }}>
                            <Checkbox
                                checked={allSelected}
                                indeterminate={indeterminate}
                                onChange={handleToggleAll}
                            />
                        </th>
                        <th className='barcode'>Barcode item</th>
                        <th className='file'>File DST</th>
                        <th className='time'>Thời gian tạo</th>
                        <th className='update'>Thời cập nhật</th>
                        <th className='quantity text-center'>Số lượng tái sử dụng</th>
                        <th className='action'>Thao tác</th>
                    </tr>
                </thead>
                <tbody className="PackingItemRow">
                    {
                        data.map((item, i) => {
                            const barcodeNumber = `${_.get(item, 'org_barcode_item.barcode_number')}_${_.get(item, 'org_barcode_item.item_number')}`
                            return (
                                <tr key={item._id}>
                                    <td>
                                        <Checkbox
                                            checked={selectedRowIds.includes(item._id)}
                                            onChange={() => handleToggleRow(item._id)}
                                        />
                                    </td>
                                    <td>
                                        <Tooltip title="Xem lịch sử" placement='right'>
                                            <span 
                                            className='cursor-pointer text-primary font-weight-bold' 
                                            onClick={() => {
                                                setIsOpenModalHistory(true)
                                                setItemId(_.get(item, '_id'))
                                            }}
                                            >{barcodeNumber}</span>
                                        </Tooltip>
                                        <HistoryModal
                                            visible={isOpenModalHistory && itemId === _.get(item, '_id')}
                                            idItem={itemId}
                                            api={getHistoryEmbroideryDesign}
                                            toggleModal={() => {
                                                setIsOpenModalHistory(false)
                                                setItemId('')
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <div className="list-file">
                                            {
                                                Object.entries(_.get(item, 'embroidery_area_info.embroidery_files', {})).map(([side, files]) => {
                                                    return (
                                                        <div className="file-item cursor-pointer">
                                                            <Popover
                                                                content={renderLinkFile(files)}
                                                                placement='topLeft'
                                                            >
                                                                {side}
                                                            </Popover>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </td>
                                    <td>{moment(_.get(item, 'created_at')).format("DD/MM/YYYY HH:mm")}</td>
                                    <td>{moment(_.get(item, 'updated_at')).format("DD/MM/YYYY HH:mm")}</td>
                                    <td className='text-center'>{_.get(item, 'orders')}</td>
                                    <td>
                                        <i
                                            className="fa fa-pencil-square-o cursor-pointer mr-2"
                                            title='Chỉnh sửa'
                                            style={{ fontSize: 20 }}
                                            onClick={() => {
                                                setIsEdit(true)
                                                setProductType(_.get(item, 'sku'))
                                                setIdFocus(_.get(item, '_id'))
                                            }}
                                        />
                                        <ModalEmbroideryInfo
                                            isOpen={isEdit && _.get(item, '_id') === idFocus}
                                            meta={_.get(item, 'org_barcode_item.meta')}
                                            status={_.get(item, 'org_barcode_item.status')}
                                            embroideryAreaInfo={_.get(item, 'embroidery_area_info', {})}
                                            reloadItems={reload}
                                            marketplace={_.get(item, 'org_barcode_item.barcode_number')}
                                            itemNumber={_.get(item, 'org_barcode_item.item_number')}
                                            dataType={dataType}
                                            productType={_.get(item, 'sku')}
                                            onCancel={() => {
                                                setIsEdit(false)
                                                setSelectItems(allIds)
                                            }}
                                            sideActive={sideActive || []}
                                            onActiveSide={e => setSideActive(e)}
                                            threadColorNote={_.get(item, 'org_barcode_item.thread_color_note')}
                                            idItem={_.get(item, '_id')}
                                            items={items}
                                            selectItems={selectItems}
                                            setSelectItems={setSelectItems}
                                            allIds={allIds}
                                            orderId={_.get(item, '_id')}
                                        />
                                        <i
                                            className="fa fa-trash-o cursor-pointer"
                                            title='Xóa'
                                            style={{ fontSize: 20, color: 'red' }}
                                            onClick={() => {
                                                setIsOpenModalDelete(true)
                                                setIdFocus(_.get(item, '_id'))
                                            }}
                                        />
                                        <Modal
                                            className='SameEmbroideryInfoModal'
                                            title='Xoá thiết kế thêu gốc'
                                            visible={isOpenModalDelete && _.get(item, '_id') === idFocus}
                                            okText='Delete'
                                            onCancel={() => {
                                                setIsOpenModalDelete(false)
                                                setSelectItems(allIds)
                                                setOrderErr({})
                                            }}
                                            onOk={() => _handleDelete(_.get(item, '_id'))}
                                            maskClosable={false}
                                            width={800}
                                            destroyOnClose
                                        >
                                            <h5 className='text-danger'>Chắc chắn xóa thiết kế thêu này?</h5>
                                            {
                                                !!items.length &&
                                                <ModalReusedEmbroideryDesignOrders
                                                    orderTemplate={`#${_.get(item, 'org_barcode_item.marketplace')}_${_.get(item, 'org_barcode_item.item_number')}`}
                                                    items={items}
                                                    isActionDelete={true}
                                                    selectItems={selectItems}
                                                    setSelectItems={setSelectItems}
                                                    allIds={allIds}
                                                    ordersErr={ordersErr}
                                                />
                                            }
                                        </Modal>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    {
                        !loading && (!data || data.length === 0) &&
                        <tr>
                            <td colSpan={5}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div >
    )
}

export default ReuseEmbroideryInfoTable